import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import { type BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function ButtonSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div className="button-wrapper">
      <a
        {...useBlockProps.save({ className: "button" })}
        href={attributes.linkUrl}
        target={attributes.openInNewTab ? "_blank" : undefined}
      >
        {attributes.text}
      </a>
    </div>
  );
}
